// Keep existing deep-link filters compatible; exclude commands such as assign=1.
const keys: Record<string, string[]> = {
  "/projects": ["tab"],
  "/tasks": ["tab", "project_id", "type", "assignment_type"],
  "/leave-requests": ["inbox"],
  "/production": ["source"],
  "/delivery": ["source"]
};
export function listRouteKeys(path: string): readonly string[] {
  if (/^\/projects\/[^/]+$/.test(path)) return ["tab", "task_filter", "task_q", "task_assignee", "task_type", "task_location", "task_status", "task_sort", "task_dir", "task_page_size", "task_page", "task_view"];
  return keys[path] ?? [];
}
